import React from 'react';

import { Select } from '@aline/common';
import clsx from 'clsx';
import { AlineButton, AlineTooltip } from 'src/components';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  dialogActions: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(3),
  },
  submitButton: {
    marginLeft: theme.spacing(1),
  },
}));

interface AlineDialogButtonsProps {
  cancelHandler: (event?: React.MouseEvent<Element, MouseEvent> | undefined) => void;
  cancelText?: string;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  primaryDataCy?: string;
  showCancelButton?: boolean;
  submitHandler?: () => void;
  submitText?: string;
  submitTooltipMsg?: string;
}

export function AlineDialogButtons({
  cancelHandler,
  cancelText = 'Cancel',
  className,
  disabled = false,
  loading = false,
  primaryDataCy = Select.dialog.submitButton,
  showCancelButton = true,
  submitHandler,
  submitText = 'Submit',
  submitTooltipMsg,
}: AlineDialogButtonsProps): JSX.Element {
  const { classes } = useStyles();
  const submitButtonClassName = showCancelButton ? classes.submitButton : undefined;
  const cancelButton = showCancelButton ? (
    <AlineButton color="primary" disabled={loading} variant="outlined" onClick={cancelHandler}>
      {cancelText}
    </AlineButton>
  ) : null;

  if (submitTooltipMsg) {
    return (
      <div className={clsx(classes.dialogActions, className)}>
        {cancelButton}
        <AlineTooltip arrow placement="bottom" title={submitTooltipMsg}>
          <div className={submitButtonClassName}>
            <AlineButton
              color="primary"
              data-cy={primaryDataCy}
              disabled={disabled}
              loading={loading}
              type="submit"
              variant="contained"
              onClick={submitHandler}
            >
              {submitText}
            </AlineButton>
          </div>
        </AlineTooltip>
      </div>
    );
  }

  return (
    <div className={clsx(classes.dialogActions, className)}>
      {cancelButton}
      <AlineButton
        className={submitButtonClassName}
        color="primary"
        data-cy={primaryDataCy}
        disabled={disabled}
        loading={loading}
        type="submit"
        variant="contained"
        onClick={submitHandler}
      >
        {submitText}
      </AlineButton>
    </div>
  );
}
